class BSPopover extends HTMLElement {
  constructor() {
    super();
    this.options = {};

    if(this.dataset.bsTrigger != undefined)
      this.options.trigger = this.dataset.bsTrigger;
    
    new bootstrap.Popover(this, this.options);
  }
}
if (!window.customElements.get("bs-popover")) {
  window.customElements.define("bs-popover", BSPopover);
}

class ThemeTooltip {
  constructor(element) {
    this.options = {};
    new bootstrap.Tooltip(element, this.options);
  }
}

class BSTooltip extends HTMLElement {
  constructor() {
    super();
    new ThemeTooltip(this);
  }
}
if (!window.customElements.get("bs-tooltip")) {
  window.customElements.define("bs-tooltip", BSTooltip);
}

class BSModal extends HTMLElement {
  delay; modal; scroll; scrollHandler; cansShow; days; backdrop;

  connectedCallback(){
    this.init();
  } 

  init = () => {
    // Determina se il modal deve essere mostrato in base a localStorage
    // Permette di non re-mostrare un modal che l'utente ha già visto
    this.backdrop = this.dataset.backdrop != "false";
    this.delay = isNaN(parseInt(this.dataset.delay)) ? 0 : parseInt(this.dataset.delay);
    this.scroll = isNaN(parseInt(this.dataset.scroll)) ? 0 : parseInt(this.dataset.scroll);
    this.days = isNaN(parseInt(this.dataset.remember)) ? 0 : parseInt(this.dataset.remember);
    this.modal = bootstrap.Modal.getOrCreateInstance(this, {backdrop: this.backdrop});

    // Se il modal può essere mostrato, configura i trigger (delay, scroll, remember)
    if(!this.canShow) return;
    if(this.dataset.delay != undefined) this.handleDelay();
  
    if(this.dataset.scroll != undefined){
      this.scrollHandler = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler, false);
    }

    if(this.dataset.remember != undefined && this.days > 0){
      this.addEventListener('hidden.bs.modal', () => this.remember());
    }

    if(this.isUrlHashTarget) {
      this.show();
    }
    window.addEventListener('hashchange', () => {
      if(this.isUrlHashTarget) {
        this.show();
      }
    });

    this.addEventListener('hidden.bs.modal', () => {
      if(this.isUrlHashTarget) {
        history.replaceState("", document.title, window.location.pathname + window.location.search);
        window.dispatchEvent(new Event('hashchange'));
      }
    });
  }

  get isUrlHashTarget() {
    const url = new URL(window.location);
    return url.hash === `#${this.id}`;
  }

  remember = () => {
    // Salva un timestamp nel localStorage quando il modal è chiuso
    // Data futura = Data attuale + numero di giorni * millisecondi per giorno
    localStorage.setItem(this.id, Date.now() + this.days * 24 * 60 * 60 * 1000);
  } 

  get canShow() {
    // Recupera il timestamp salvato e verifica se è passato il periodo di "remember"
    // Se non c'è timestamp o è scaduto, il modal può essere mostrato
    const stamp = parseInt(localStorage.getItem(this.id));
    return isNaN(stamp) || stamp < Date.now();
  }

  handleScroll = () => {
    // Mostra il modal quando l'utente ha scrollato fino a una percentuale della pagina
    // Calcolo: rapporto fra (posizione scroll + altezza finestra) diviso altezza totale pagina
    // Se > percentuale specificata nei data, mostra il modal
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const scrollPercentage = this.scroll / 100;
    if(scrollPosition / pageHeight > scrollPercentage){
      this.show();
      // Rimuove il listener per non trigger il modal ripetutamente
      window.removeEventListener('scroll', this.scrollHandler, false);
    }
  }

  handleDelay = () => {
    // Mostra il modal dopo un numero di millisecondi specificato nei data
    setTimeout(() => {
      this.show();
    }, this.delay);
  }

  show = () => {
    this.modal.show();
  }

  hide = () => {
    this.modal.hide();
  }
}
if (!window.customElements.get("bs-modal")) {
  window.customElements.define("bs-modal", BSModal);
}

class BSTab extends HTMLElement {
  constructor() {
    super();
    this.tab = new bootstrap.Tab(this);
    this.init();
  }

  activate = () => {
    const nav = this.closest('.nav');
    if(nav){
      nav.classList.add('active');
    }
  }

  deactivate = () => {
    const nav = this.closest('.nav');
    if(nav){
      nav.classList.remove('active');
    }
  }

  init = () =>{
    // Al mouseover attiva il tab per UX di navigazione da desktop
    this.addEventListener('mouseover', (e) => {
      e.preventDefault();
      this.tab.show();
    });

    // Se il tab ha un href, naviga a quella URL al click
    this.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.href != undefined)
        location.href = this.href;
    });
    
    // Permette di attivare il tab con tastiera (Enter o Spazio)
    this.addEventListener('keydown', (e) => {
      console.log('please: ', e.key, e.code);
      if(e.key === 'Enter' || e.key === ' '){
        console.log('open sesame');
        this.tab.show();
      }
    });

    // Quando il tab diventa attivo, sincronizza lo stato visuale
    this.addEventListener('shown.bs.tab', () => {
      console.log('activated');
      this.activate();
    });

    this.addEventListener('hidden.bs.tab', () => {
      this.deactivate();
    });
    
  }
}
if (!window.customElements.get("bs-tab")) {
  window.customElements.define("bs-tab", BSTab);
}

class BSToast extends HTMLElement {
  toast;
  constructor() {
    super();
    this.toast = new bootstrap.Toast(this);
  }

  show = () => {
    this.toast.show();
  }

  hide = () => {
    this.toast.hide();
  }
}
if (!window.customElements.get("bs-toast")) {
  window.customElements.define("bs-toast", BSToast);
}